/**
 * 工具类
 */
import CryptoJS from 'crypto-js'
export default {//加密
  encrypt(word, keyStr){ 
    keyStr = keyStr ? keyStr : 'MOBILETERMINAL19';
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: CryptoJS.enc.Utf8.parse('0102030405060708'),
        mode:CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString().toUpperCase();
  },
  //解密
  decrypt(word, keyStr){  
    keyStr = keyStr ? keyStr : 'MOBILETERMINAL19';
    var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    var decrypt = CryptoJS.AES.decrypt(srcs, CryptoJS.enc.Utf8.parse(keyStr), {
      iv: CryptoJS.enc.Utf8.parse('0102030405060708'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  },
  wechatUtil: {
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    }
  },
  URL: {
    getSearch() {
      let url = window.location.search; //获取url中"?"符后的字串
      let theRequest = {};
      if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    getUrlKey(name){
      let reg=`(^|&)${name}=([^&]*)(&|$)`;
      let r=window.location.search.substr(1).match(reg);
      if(r !== null){
        return unescape(r[2]);
      }else{
        return false;
      }
    },
    //判断url上是否存在某个key
    isUrlKey(name){
      let r=window.location.href.indexOf(name);
      if(r && r!=-1){
        return true;
      }else{
        return false;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js